<script setup>
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import TextareaField from '@js/components/fields/TextareaField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { toastError, toastSuccess } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { ticket, callback, currentDraft } = defineProps({
    ticket: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: true,
    },
    currentDraft: {
        type: String,
        required: false,
        default: '',
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const isOpen = ref(false);

const form = reactive({
    additionalInstructions: '',
});

const validationSchema = object({
    additionalInstructions: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.projectManagement.task.postGenerateAIAnswer', {
                ticket: ticket.id,
            }),
            {
                additionalInstructions: form.additionalInstructions,
                currentDraft: currentDraft,
            },
        )
        .then((response) => {
            isOpen.value = false;
            toastSuccess('Généré avec succès.');
            callback(response.data.answer);
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}
</script>

<template>
    <DialogModal v-model="isOpen">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Générer une réponse avec l'IA </template>

        <template #full-content>
            <FormRoot
                v-slot="{ errors }"
                :validation-schema="validationSchema"
                :submit="submit"
            >
                <FormColumn>
                    <FormContent>
                        <TextareaField
                            v-model="form.additionalInstructions"
                            field-name="additionalInstructions"
                            field-id="additionalInstructions"
                            label="Instructions supplémentaires"
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                    submit-text="Générer"
                    submitting-text="Génération en cours..."
                />
            </FormRoot>
        </template>
    </DialogModal>
</template>
